import { auth } from './firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import './components/auth-modal';
import './components/add-balance-modal';
import './components/account-form';
import { API_ENDPOINT } from './constants';

class WalletManager {
  private currentBalance = 0;

  async loadBalance() {
    try {
      const token = localStorage.getItem('auth_token');
      if (!token) return;

      const response = await fetch(API_ENDPOINT+'/api/wallet/balance', {
        credentials: 'include',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        this.currentBalance = data.balance;
        this.updateBalanceDisplay();
      }
    } catch (error) {
      console.error('Failed to load wallet balance:', error);
    }
  }

  updateBalanceDisplay() {
    const balanceElement = document.querySelector('#wallet-balance');
    if (balanceElement) {
      balanceElement.textContent = `$${this.currentBalance.toFixed(2)}`;
    }
  }

  showAddBalanceModal() {
    const modal = document.querySelector('#add-balance-modal') as any;
    if (modal) {
      modal.show();
    }
  }
}

class App {
  private walletManager = new WalletManager();

  init() {
    this.setupAuthStateListener();
    this.setupEventListeners();
    this.setupWalletListeners();
  }

  private setupAuthStateListener() {
    onAuthStateChanged(auth, (user) => {
      const authBtn = document.querySelector('#auth-btn');
      const walletBtn = document.querySelector('#wallet-btn');
      const userEmailElement = document.querySelector('#user-email');

      if (user) {
        // User is signed in
        if (authBtn) {
          authBtn.textContent = 'Go to Dashboard';
          (authBtn as HTMLButtonElement).onclick = () => {
            window.location.href = '/account';
          };
        }

        if (walletBtn) {
          walletBtn.classList.remove('hidden');
          walletBtn.classList.add('flex');
        }

        if (userEmailElement) {
          userEmailElement.textContent = user.email || '';
        }

        // Load wallet balance
        this.walletManager.loadBalance();

        // Store auth token
        user.getIdToken().then(token => {
          localStorage.setItem('auth_token', token);
        });
      } else {
        // User is signed out
        if (authBtn) {
          authBtn.innerHTML = '<i class="fas fa-user mr-2"></i>Join Server';
          (authBtn as HTMLButtonElement).onclick = () => {
            this.showAuthModal();
          };
        }

        if (walletBtn) {
          walletBtn.classList.add('hidden');
          walletBtn.classList.remove('flex');
        }

        // Clear stored token
        localStorage.removeItem('auth_token');
      }
    });
  }

  private setupEventListeners() {
    // Auth button click
    const authBtn = document.querySelector('#auth-btn');
    if (authBtn) {
      authBtn.addEventListener('click', () => {
        if (!auth.currentUser) {
          this.showAuthModal();
        }
      });
    }

    // Sign out button
    const signOutBtn = document.querySelector('#sign-out-btn');
    if (signOutBtn) {
      signOutBtn.addEventListener('click', () => {
        auth.signOut();
      });
    }

    // Enlist tournament buttons
    const enlistBtns = document.querySelectorAll('#enlist-tournament-btn, #enlist-tournament-btn-2');
    enlistBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (auth.currentUser) {
          // Redirect to tournaments page instead of handling enlistment here
          window.location.href = '/tournaments';
        } else {
          this.showAuthModal();
        }
      });
    });
  }

  private setupWalletListeners() {
    // Wallet button click
    const walletBtn = document.querySelector('#wallet-btn');
    if (walletBtn) {
      walletBtn.addEventListener('click', () => {
        this.walletManager.showAddBalanceModal();
      });
    }

    // Listen for balance updates
    document.addEventListener('balance-updated', (event: any) => {
      this.walletManager.currentBalance = event.detail.balance;
      this.walletManager.updateBalanceDisplay();
    });
  }

  private showAuthModal() {
    const authModal = document.querySelector('#auth-modal') as any;
    if (authModal) {
      authModal.show();
    }
  }

  private async handleTournamentEnlistment() {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(API_ENDPOINT+'/api/tournament/enlist', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        // Update wallet balance in UI
        this.walletManager.currentBalance = data.balance;
        this.walletManager.updateBalanceDisplay();

        alert(`🎉 Successfully enlisted for the next tournament!\n💰 Entry fee: $${data.entry_fee}\n💰 Remaining balance: $${data.balance.toFixed(2)}`);
      } else {
        const error = await response.text();
        alert(`Failed to enlist: ${error}`);
      }
    } catch (error) {
      console.error('Tournament enlistment failed:', error);
      alert('Failed to enlist for tournament. Please try again.');
    }
  }
}

// Initialize app when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const app = new App();
  app.init();
});
